function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatCreatedAt(ms) {
  var n = Number(ms);
  if (!n) {
    return '—';
  }
  var date = new Date(n);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}
function approvalState(summary) {
  var _summary$approved;
  var approved = Number((_summary$approved = summary === null || summary === void 0 ? void 0 : summary.approved) !== null && _summary$approved !== void 0 ? _summary$approved : 0);
  if (approved === 1) {
    return {
      status: 'Approved',
      action: ''
    };
  }
  if (approved === 2) {
    return {
      status: 'Pending approval',
      action: ''
    };
  }
  if (approved === -1) {
    return {
      status: 'Rejected',
      action: 'Resubmit'
    };
  }
  return {
    status: 'Not submitted',
    action: 'Submit to Main Store'
  };
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    _ref$caption = _ref.caption,
    caption = _ref$caption === void 0 ? '' : _ref$caption;
  var rows = (listings || []).map(function (summary) {
    var _summary$returnTitle, _summary$returnPrice, _ref2, _summary$quantity_tot;
    var signature = escapeHtml(summary.listing_signature || '');
    var title = escapeHtml(((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || summary.title || 'Untitled Item');
    var category = escapeHtml(summary.category || '');
    var price = escapeHtml(((_summary$returnPrice = summary.returnPrice) === null || _summary$returnPrice === void 0 ? void 0 : _summary$returnPrice.call(summary)) || '');
    var quantity = Number((_ref2 = (_summary$quantity_tot = summary.quantity_total) !== null && _summary$quantity_tot !== void 0 ? _summary$quantity_tot : summary.quantity_available) !== null && _ref2 !== void 0 ? _ref2 : 0) || 0;
    var created = escapeHtml(formatCreatedAt(summary.created_at));
    var approval = approvalState(summary);
    var action = approval.action ? "<button type=\"button\" class=\"saito-button-secondary listing-submit-main\" data-action=\"submit-main-store\">".concat(escapeHtml(approval.action), "</button>") : '';
    return "\n          <tr data-signature=\"".concat(signature, "\">\n            <td>").concat(title, "</td>\n            <td>").concat(category, "</td>\n            <td>").concat(price || '—', "</td>\n            <td>").concat(quantity, "</td>\n            <td>").concat(created, "</td>\n            <td class=\"listing-approval\">\n              <span class=\"listing-approval-status\">").concat(escapeHtml(approval.status), "</span>\n              ").concat(action, "\n            </td>\n          </tr>");
  }).join('');
  var captionHtml = caption ? "<caption>".concat(escapeHtml(caption), "</caption>") : '';
  return "\n    <div class=\"listings-table-wrap\">\n      <table class=\"listings-table\">\n        ".concat(captionHtml, "\n        <thead>\n          <tr>\n            <th scope=\"col\">Title</th>\n            <th scope=\"col\">Category</th>\n            <th scope=\"col\">Price</th>\n            <th scope=\"col\">Quantity</th>\n            <th scope=\"col\">Created_at</th>\n            <th scope=\"col\">Main Store</th>\n          </tr>\n        </thead>\n        <tbody>").concat(rows, "\n        </tbody>\n      </table>\n    </div>\n  ");
};